import { render } from "./ReferralPassThru.vue?vue&type=template&id=8b2edbae&scoped=true&ts=true"
import script from "./ReferralPassThru.vue?vue&type=script&lang=ts"
export * from "./ReferralPassThru.vue?vue&type=script&lang=ts"

import "./ReferralPassThru.vue?vue&type=style&index=0&id=8b2edbae&scoped=true&lang=scss"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2edbae"]])

export default __exports__